import { Title, Text, Group, Stack } from '@mantine/core';
import { AnimateDiv } from '@/components/Common/AnimateDiv';

export const Canvas = () => {
  return (
    <section className="flex flex-col mt-32 max-w-[1520px] mx-auto px-[20px] lg:px-[80px]">
      <AnimateDiv>
        <Title order={2} className="text-xl lg:text-5xl font-bold text-center mt-8">
          インタラクティブキャンバスによる豊かな対話体験
        </Title>
      </AnimateDiv>
      <AnimateDiv>
        <Text c="dimmed" className="text-sm lg:text-xl pb-12 mt-8">
          GBase
          Supportのインタラクティブキャンバスなら、地図やアンケートフォーム、動画など、さまざまな動的コンテンツを会話内に埋め込み可能。
        </Text>
      </AnimateDiv>
      <AnimateDiv>
        <Group wrap="nowrap" justify="space-between" align="end" className="px-4 lg:px-40">
          <img src="/home/canvas.png" alt="" className="w-1/2 mb-8" />
          <img src="/home/conversation.png" alt="" className="w-1/2" />
        </Group>
      </AnimateDiv>

      <Group justify="space-between" align="stretch" gap="xl" className="mb-20 lg:flex-nowrap">
        <AnimateDiv className="w-full lg:w-1/3">
          <Stack className="rounded-lg bg-gray-50 h-full px-4 lg:px-8 py-6 lg:py-10" gap={0}>
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 20.5519C5 19.6386 5.61862 18.8414 6.50325 18.6146L43.0983 9.23121C43.67 9.08462 44.2772 9.19803 44.7575 9.54107L51 14L44 36L12 51L5.83752 46.5982C5.31193 46.2228 5 45.6167 5 44.9708V20.5519Z"
                fill="black"
              />
              <path
                d="M49.5 39.835L13.5 49.0664V25.1641L49.5 15.9326V39.835Z"
                fill="#F9FAFB"
                stroke="black"
                strokeWidth="3"
              />
              <path d="M29 25.5V28.5L18 31.5V28.5L29 25.5Z" fill="black" />
            </svg>
            <Title order={4} className="text-base lg:text-2xl font-bold mt-4">
              視覚型インタラクティブキャンバス
            </Title>
            <Text className="text-sm lg:text-lg text-black/60 mt-4">
              文字だけの対話から一歩前へ。直感的なビジュアルインターフェースを実現。
              <br />
              インタラクティブキャンバスが、より魅力的でユーザーフレンドリーなコンテンツ探索体験を提供します。
            </Text>
          </Stack>
        </AnimateDiv>
        <AnimateDiv className="w-full lg:w-1/3">
          <Stack className="rounded-lg bg-gray-50 h-full px-4 lg:px-8 py-6 lg:py-10" gap={0}>
            <svg width="59" height="57" viewBox="0 0 59 57" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13 10.877C13 9.96773 13.6134 9.17289 14.4929 8.94235L37.5157 2.9079C38.0973 2.75546 38.7166 2.87275 39.2022 3.22729L43 6.00033L38.4348 36.667L18 47L13.8173 43.933C13.3036 43.5562 13 42.9572 13 42.3201V10.877Z"
                fill="black"
              />
              <path
                d="M41.5 39.9248L30.2012 52.1143L19.5 46.1211V13.6465L41.5 7.93848V39.9248Z"
                fill="#F9FAFB"
                stroke="black"
                strokeWidth="3"
              />
              <path d="M28.5 21V32L25 33V22L28.5 21Z" fill="black" />
              <path d="M36.5 19V30L33 31V20L36.5 19Z" fill="black" />
              <path d="M41.4024 39L19.9024 46L30.5005 52.0002L41.4024 39Z" fill="black" stroke="black" />
            </svg>
            <Title order={4} className="text-base lg:text-2xl font-bold mt-4">
              高度にカスタマイズ可能
            </Title>
            <Text className="text-sm lg:text-lg text-black/60 mt-4">
              必要に応じて地図、画像、Webコンテンツ、独自レイアウトなどを簡単に組み込み、キャンバスを自在にカスタマイズ。顧客体験を完全にコントロールできます。
            </Text>
          </Stack>
        </AnimateDiv>
        <AnimateDiv className="w-full lg:w-1/3">
          <Stack className="rounded-lg bg-gray-50 h-full px-4 lg:px-8 py-6 lg:py-10" gap={0}>
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M23.6406 4C25.5542 4 27.3967 4.39128 29.1221 5.11328L29.1543 5.10254L37.5 9L35.9551 10.4199C39.2407 14.525 41.2822 20.2581 41.2822 26.6025C41.2822 36.6183 36.1967 45.1107 29.1543 48.0771L29 51C28.9947 51.0805 24.4524 50.5306 20.2012 48.7734C18.831 48.4264 17.5184 47.8765 16.2822 47.1484C16.1597 47.0974 16.0394 47.0486 15.9229 47L15.9258 46.9336C10.0496 43.2661 6.00003 35.5405 6 26.6025C6 14.1197 13.8979 4.00028 23.6406 4Z"
                fill="black"
              />
              <path d="M36 7L27.5 4.5L22 7.5L16 47H20L26 41.5L36 7Z" fill="black" />
              <path
                d="M32.5 8.0127C41.0076 8.0127 48.5 17.0421 48.5 29.0127C48.5 40.9833 41.0076 50.0127 32.5 50.0127C23.9924 50.0127 16.5 40.9833 16.5 29.0127C16.5 17.0421 23.9924 8.0127 32.5 8.0127Z"
                fill="#F9FAFB"
                stroke="black"
                strokeWidth="3"
              />
              <path d="M33 17.5V32.5L39.5 39" stroke="black" strokeWidth="3" />
            </svg>
            <Title order={4} className="text-base lg:text-2xl font-bold mt-4">
              リアルタイム更新
            </Title>
            <Text className="text-sm lg:text-lg text-black/60 mt-4">
              入力やデータ更新があるたびに、キャンバスの内容が即座に切り替わり、待ち時間ゼロでダイナミックな体験を提供します。
            </Text>
          </Stack>
        </AnimateDiv>
      </Group>
    </section>
  );
};
